import { decisioningCreativeComponentTagMarkupPattern } from "./constants";
import { isDecisioningCreativeComponentName } from "./isDecisioningCreativeComponentName";
import type { DecisioningCreativeComponentName } from "./types";

/**
 * Scans a string for decisioning_creative_component liquid tags and returns allowed component names.
 */
export const extractDecisioningCreativeComponentNames = (
  input: string | null | undefined
): DecisioningCreativeComponentName[] => {
  if (!input) {
    return [];
  }

  const tagMarkupRegex = new RegExp(decisioningCreativeComponentTagMarkupPattern, "g");
  const matches = [...input.matchAll(tagMarkupRegex)];
  const names = matches.map((match) => match[1]);
  const uniqueNames = [...new Set(names)];

  return uniqueNames.filter(isDecisioningCreativeComponentName);
};
